/* Sully & Co. native size chart (replaces the Kiwi Size Chart app).
   The chart content comes from <template id="SullySizeChartBody"> (snippets/sully-size-chart.liquid).
   Adds a "Size Chart" link to the Size row and opens the chart in a <dialog>. */
(function () {
  var source = document.getElementById('SullySizeChartBody');
  if (!source || !source.content) return;

  var dialog;

  function make(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function build() {
    dialog = make('dialog', 'sully-sc');
    dialog.setAttribute('aria-labelledby', 'SullySizeChartTitle');

    var head = make('div', 'sully-sc__head');
    var title = make('h2', 'sully-sc__title', source.getAttribute('data-title') || 'Size Chart');
    title.id = 'SullySizeChartTitle';
    var close = make('button', 'sully-sc__close');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close size chart');
    close.innerHTML =
      '<svg viewBox="0 0 18 18" aria-hidden="true" focusable="false"><path d="M2 2l14 14M16 2L2 16" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>';
    close.addEventListener('click', function () {
      dialog.close();
    });
    head.appendChild(title);
    head.appendChild(close);

    var body = make('div', 'sully-sc__body');
    body.appendChild(source.content.cloneNode(true));

    dialog.appendChild(head);
    dialog.appendChild(body);

    // A click on the dimmed backdrop (outside the panel) closes the chart
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('sully-sc-lock');
    });
    document.body.appendChild(dialog);
  }

  function open() {
    if (!dialog) build();
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add('sully-sc-lock');
  }

  function addLink() {
    document.querySelectorAll('.product__content .radio__legend--size').forEach(function (legend) {
      if (legend.querySelector('.sully-sc-link')) return;
      var link = make('button', 'sully-sc-link', 'Size Chart');
      link.type = 'button';
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', open);
      legend.appendChild(link);
    });
  }

  addLink();
  // The variant picker can re-render its options; put the link back if it goes missing
  var content = document.querySelector('.product__content');
  if (content && 'MutationObserver' in window) {
    new MutationObserver(addLink).observe(content, { childList: true, subtree: true });
  }
})();
